import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v2_dashboard_stats = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/dashboard/stats`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_dashboard_priorities = async (page,limit) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/dashboard/priorities/${page}/${limit}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_dashboard_header_count = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/dashboard/header/count`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

